import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import AdminService from '../../../../../../services/admin.api';
import { useTranslation } from 'react-i18next';

function useCreateUser() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [inputValues, setInputValues] = useState<Record<string, string>>({});
  const [error, setError] = useState('');

  const createUser = useCallback(async () => {
    try {
      setLoading(true);
      const user = await AdminService.createAdmin({
        name: inputValues?.firstName,
        familyName: inputValues?.familyName,
        email: inputValues?.email,
        password: inputValues?.password,
        phone: inputValues?.phone,
        roles: [inputValues.roles],
      });
      if (user) {
        navigate('/admin/internal_users/overview');
        // add toast after user has been created
        toast({
          title: t('toast.title.success'),
          description: t('toast.description.user_created'),
          status: 'success',
          duration: 3000,
        });
      }
    } catch (e) {
      const error = e as AxiosError;
      setError(error.message);
    }
    setLoading(false);
  }, [inputValues, navigate, toast, t]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  return {
    handleChange,
    createUser,
    loading,
    error,
  };
}

export default useCreateUser;
